import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';

import { injectCatchHttpError } from '../../../core/errors/catch-http-error.util';
import type { IProjectTag } from '../../models';
import { ApiProjectsService } from '../../services/api/api-projects.service';
import * as projectTagsActions from './project-tags.actions';

@Injectable()
export class ProjectTagsEffects {
  private apiProjects = inject(ApiProjectsService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  updateProjectTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectTagsActions.updateProjectTag),
      exhaustMap(({ tagId, params }) =>
        this.apiProjects.updateProjectTag(tagId, params).pipe(
          map((tag: IProjectTag) => projectTagsActions.loadActiveProjectTagSuccess({ tag })),
          this.catchHttpError(() => projectTagsActions.loadActiveProjectTagFail()),
        ),
      ),
    ),
  );

  createProjectTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(projectTagsActions.createProjectTag),
      exhaustMap(({ params }) =>
        this.apiProjects.createProjectTag(params).pipe(
          map((tag: IProjectTag) => projectTagsActions.loadActiveProjectTagSuccess({ tag })),
          this.catchHttpError(() => projectTagsActions.loadActiveProjectTagFail()),
        ),
      ),
    ),
  );
}
